export const initialAssignEmployeesAndGroupsData = {
  id: '',
  all_users: 0,
  user_ids: [] as Array<any>,
  group_ids: [] as Array<any>,
};
